
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1696"}},[_c('path',{attrs:{"data-name":"Rectangle 2403","fill":"none","d":"M0 0h25v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1695","fill":"#3c3c3c"}},[_c('path',{attrs:{"data-name":"Path 1043","d":"M23.5 6.374a1.5 1.5 0 00-1.5 1.5v5.3H3V1.5a1.5 1.5 0 00-3 0v17a1.5 1.5 0 003 0v-2.321h19V18.5a1.5 1.5 0 003 0V7.874a1.5 1.5 0 00-1.5-1.5z"}}),_c('path',{attrs:{"data-name":"Path 1044","d":"M6.304 11.408h12.045a1.5 1.5 0 000-3H6.304a1.5 1.5 0 100 3z"}}),_c('path',{attrs:{"data-name":"Path 1045","d":"M6.304 6.867h3.978a1.5 1.5 0 000-3H6.304a1.5 1.5 0 100 3z"}})])])])
          )
        }
      }
    